import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "main-content type4" };
const _hoisted_2 = { class: "content-wrapper" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { class: "ta-r my-2 brg-error-message" };
import { ref, watch, } from 'vue';
import { i18n } from '@/locales';
import { getFormValueForPinia, setFormValueForPinia, validateForm, } from '@/utils/form';
import InputRow from '@/components/Form/InputRow.vue';
import CardSection from '@/components/Common/CardSection.vue';
import BoardFooter from '@/components/Common/BoardFooter.vue';
import { createRequestMapFormRule } from '@/form/form-rules/requestMap';
import { pStore } from '@/pinia';
import { storeToRefs } from 'pinia';
import AxiosResponse from '@/error/AxiosResponse';
import vuexStore from '@/vuex-store';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { routeName } from '@/constants/routeName';
import { useRouter } from 'vue-router';
import { BusinessError } from '@/error';
import BrgMapAddressItem from './BrgMapAddressItem.vue';
import SelectedAddressItem from './SelectedAddressItem.vue';
import SelectedAddressMap from './SelectedAddressMap.vue';
import BrgMapSearchForm from './BrgMapSearchForm.vue';
import DaumMapAddressItem from './DaumMapAddressItem.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const router = useRouter();
        const formRule = createRequestMapFormRule();
        const storeRequestMap = pStore.piniaRequestMap;
        const { formData, } = storeToRefs(storeRequestMap);
        const getFormValue = (key) => getFormValueForPinia(formData, key);
        const setFormValue = (key, value) => setFormValueForPinia(formData, key, value);
        /**
         * 목록 클릭 핸들러
         */
        const handleClickReturnBtn = async () => {
        };
        const buildingNameRef = ref(null);
        const administrativeAreaRef = ref(null);
        const selectedAddressItemRef = ref(null);
        const isValid = ref(null);
        /**
         * 완료 버튼 클릭 핸들러
         */
        const handleClickSubmitBtn = async () => {
            const refList = [
                buildingNameRef.value,
                administrativeAreaRef.value,
                selectedAddressItemRef.value,
            ];
            try {
                // 유효성 검사
                const result = await validateForm(refList);
                isValid.value = result.isValid;
                if (!isValid.value) {
                    return;
                }
                await storeRequestMap.createItem();
                vuexStore.dispatch(snackbarActionType.showSuccess);
                const routeData = {
                    name: routeName.REQUEST_MAP,
                };
                router.push(routeData).catch(() => { });
            }
            catch (error) {
                console.log('error', error);
                if (error instanceof BusinessError) {
                    vuexStore.dispatch(snackbarActionType.showError, error.message);
                }
                if (error instanceof AxiosResponse) {
                    vuexStore.dispatch(snackbarActionType.showError, error.data.error.message);
                }
            }
        };
        /**
         * 작업구분 / 추가, 수정 변경시
         */
        watch(() => formData.value.operationType, (v) => {
            if (v === 'UPDATE') {
                formData.value.addressSource = 'BAROGO';
            }
            // 초기화
            storeRequestMap.formData.selectedAddress = null;
            storeRequestMap.formData.newPosition = null;
            storeRequestMap.formData.isChangePosition = false;
        });
        return (_ctx, _cache) => {
            const _component_v_radio = _resolveComponent("v-radio");
            const _component_v_radio_group = _resolveComponent("v-radio-group");
            const _component_v_tab = _resolveComponent("v-tab");
            const _component_v_tabs = _resolveComponent("v-tabs");
            const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item");
            const _component_v_tabs_window = _resolveComponent("v-tabs-window");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_form = _resolveComponent("v-form");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_v_form, { ref: "form" }, {
                        default: _withCtx(() => [
                            _createVNode(CardSection, null, {
                                titleContent: _withCtx(() => [
                                    _createVNode(InputRow, {
                                        "input-row-class": "",
                                        "is-normal-text-state": "",
                                        label: "작업구분"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_radio_group, {
                                                density: "compact",
                                                modelValue: _unref(formData).operationType,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(formData).operationType) = $event)),
                                                "hide-details": "auto",
                                                inline: ""
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_radio, {
                                                        value: "CREATE",
                                                        label: "세부지명 추가 요청"
                                                    }),
                                                    _createVNode(_component_v_radio, {
                                                        value: "UPDATE",
                                                        label: "세부지명 수정 요청"
                                                    })
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue"])
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                default: _withCtx(() => [
                                    _createVNode(InputRow, {
                                        "input-row-class": "",
                                        label: "주소 검색"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_tabs, {
                                                modelValue: _unref(formData).addressSource,
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(formData).addressSource) = $event)),
                                                color: "primary",
                                                density: "comfortable"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_tab, { value: "BAROGO" }, {
                                                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                                                            _createTextVNode(" 바로고 DB ")
                                                        ])),
                                                        _: 1 /* STABLE */,
                                                        __: [6]
                                                    }),
                                                    _createVNode(_component_v_tab, {
                                                        value: "DAUM",
                                                        disabled: _unref(formData).operationType === 'UPDATE'
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _cache[7] || (_cache[7] = _createTextVNode(" daum 주소 ")),
                                                            (_unref(formData).operationType === 'UPDATE')
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_3, " (수정 시 사용 불가) "))
                                                                : _createCommentVNode("v-if", true)
                                                        ]),
                                                        _: 1 /* STABLE */,
                                                        __: [7]
                                                    }, 8 /* PROPS */, ["disabled"])
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue"]),
                                            _createCommentVNode(" 수정시에는 daum 출력 x "),
                                            _createVNode(_component_v_tabs_window, {
                                                modelValue: _unref(formData).addressSource,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(formData).addressSource) = $event)),
                                                class: "disable-transition"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createCommentVNode(" 바로고 db "),
                                                    _createVNode(_component_v_tabs_window_item, { value: "BAROGO" }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(BrgMapSearchForm),
                                                            _createVNode(CardSection, {
                                                                class: "address-box",
                                                                p0: ""
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createCommentVNode(" 주소 검색 바로고 DB "),
                                                                    _createVNode(BrgMapAddressItem)
                                                                ]),
                                                                _: 1 /* STABLE */
                                                            })
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }),
                                                    _createCommentVNode(" daum "),
                                                    _createVNode(_component_v_tabs_window_item, { value: "DAUM" }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(CardSection, {
                                                                class: "daum-address-wrapper",
                                                                p0: ""
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createCommentVNode(" 다음 주소 "),
                                                                    _createVNode(DaumMapAddressItem)
                                                                ]),
                                                                _: 1 /* STABLE */
                                                            })
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    })
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createVNode(_component_v_divider),
                                    _createVNode(InputRow, {
                                        "is-normal-text-state": "",
                                        label: "선택한 주소"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(SelectedAddressItem)
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createVNode(InputRow, { label: "선택한 주소 좌표" }, {
                                        default: _withCtx(() => [
                                            _createVNode(SelectedAddressMap)
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createVNode(InputRow, {
                                        "is-normal-text-state": "",
                                        label: "지명구분"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_radio_group, {
                                                class: "brg-radio-group",
                                                density: "compact",
                                                modelValue: _unref(formData).operationDetailType,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(formData).operationDetailType) = $event)),
                                                "hide-details": "auto",
                                                inline: ""
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_radio, {
                                                        label: "지명",
                                                        value: "PLACE_NAME"
                                                    }),
                                                    _createVNode(_component_v_radio, {
                                                        label: "행정동(특수지명)",
                                                        value: "ADMINISTRATIVE_AREA"
                                                    }),
                                                    _createVNode(_component_v_radio, {
                                                        label: "0번지",
                                                        value: "ZERO_LOT_NUMBER"
                                                    })
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createVNode(InputRow, {
                                        label: _unref(formData).operationType === 'CREATE' ? '추가할 세부명칭' : '변경할 세부명칭'
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_text_field, {
                                                ref_key: "buildingNameRef",
                                                ref: buildingNameRef,
                                                class: "cy-title",
                                                density: "comfortable",
                                                variant: "outlined",
                                                "hide-details": "auto",
                                                "validate-on": "blur",
                                                rules: _unref(formRule).buildingName,
                                                "model-value": getFormValue('buildingName'),
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = (value) => setFormValue('buildingName', value))
                                            }, null, 8 /* PROPS */, ["rules", "model-value"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["label"]),
                                    _createVNode(InputRow, { label: "행정동(특수지명)" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_text_field, {
                                                ref_key: "administrativeAreaRef",
                                                ref: administrativeAreaRef,
                                                class: "cy-title",
                                                density: "comfortable",
                                                variant: "outlined",
                                                "hide-details": "auto",
                                                "validate-on": "blur",
                                                rules: _unref(formRule).administrativeArea,
                                                "model-value": getFormValue('administrativeArea'),
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = (value) => setFormValue('administrativeArea', value))
                                            }, null, 8 /* PROPS */, ["rules", "model-value"])
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createCommentVNode(" 선택한 주소가 없습니다. 문구 "),
                            _withDirectives(_createElementVNode("div", _hoisted_4, [
                                _createVNode(_component_v_text_field, {
                                    ref_key: "selectedAddressItemRef",
                                    ref: selectedAddressItemRef,
                                    class: "brg-input-hidden",
                                    type: "hidden",
                                    "model-value": getFormValue('selectedAddress'),
                                    rules: _unref(formRule).isSelectedAddress
                                }, null, 8 /* PROPS */, ["model-value", "rules"]),
                                _cache[8] || (_cache[8] = _createTextVNode(" 선택한 주소가 없습니다. 주소를 선택해 주세요. "))
                            ], 512 /* NEED_PATCH */), [
                                [_vShow, isValid.value === false && getFormValue('selectedAddress') === null]
                            ]),
                            _createVNode(BoardFooter, null, {
                                left: _withCtx(() => [
                                    _createCommentVNode(" 목록 "),
                                    _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: handleClickReturnBtn }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_icon, null, {
                                                default: _withCtx(() => _cache[9] || (_cache[9] = [
                                                    _createTextVNode(" mdi-chevron-left ")
                                                ])),
                                                _: 1 /* STABLE */,
                                                __: [9]
                                            }),
                                            _createTextVNode(" " + _toDisplayString(_unref(i18n).t('common.back_to_list')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })), [
                                        [
                                            _directive_btn_style,
                                            void 0,
                                            "config",
                                            {
                                                info: true,
                                                outlined: true,
                                                "size-l": true,
                                                "width-xs": true
                                            }
                                        ]
                                    ])
                                ]),
                                right: _withCtx(() => [
                                    _createCommentVNode(" 완료 "),
                                    _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                        class: "cy-final-submit-btn",
                                        onClick: handleClickSubmitBtn
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_icon, { small: "" }, {
                                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                    _createTextVNode(" mdi-check ")
                                                ])),
                                                _: 1 /* STABLE */,
                                                __: [10]
                                            }),
                                            _createTextVNode(" " + _toDisplayString(_unref(formData).operationType === 'CREATE' ? '등록 요청' : '수정 요청'), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })), [
                                        [
                                            _directive_btn_style,
                                            void 0,
                                            "config",
                                            {
                                                primary: true,
                                                "size-l": true,
                                                "width-xs": true
                                            }
                                        ]
                                    ])
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }, 512 /* NEED_PATCH */)
                ])
            ]));
        };
    }
});
